import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Cookie, Shield, Settings, Info } from 'lucide-react';

const CookieRichtliniePage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#0B0F14', color: '#E6EDF3' }}>
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-blue-400 hover:text-blue-300 mb-8"
        >
          <ArrowLeft size={20} />
          Zurück zur Startseite
        </Link>

        <div className="flex items-center gap-4 mb-8">
          <Cookie className="w-10 h-10 text-cyan-400" />
          <h1 className="text-4xl font-bold" style={{ color: '#1EA0E6' }}>
            Cookie-Richtlinie
          </h1>
        </div>

        <p className="text-gray-400 mb-8">
          Letzte Aktualisierung: {new Date().toLocaleDateString('de-DE', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>

        <div className="space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-semibold mb-4 flex items-center gap-2" style={{ color: '#7CD4FD' }}>
              <Info className="w-6 h-6" />
              1. Was sind Cookies?
            </h2>
            <p className="mb-4">
              Cookies sind kleine Textdateien, die auf Ihrem Computer oder mobilen Gerät gespeichert werden, 
              wenn Sie unsere Website besuchen. Sie ermöglichen es der Website, sich an Ihre Aktionen und 
              Einstellungen (wie Login, Sprache, Schriftgröße und andere Anzeigeeinstellungen) über einen 
              bestimmten Zeitraum zu erinnern, sodass Sie diese nicht jedes Mal erneut eingeben müssen.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 flex items-center gap-2" style={{ color: '#7CD4FD' }}>
              <Shield className="w-6 h-6" />
              2. Welche Cookies verwenden wir?
            </h2>
            
            <h3 className="text-xl font-semibold mb-3 mt-6">2.1 Technisch notwendige Cookies (Erforderlich)</h3>
            <p className="mb-4">
              Diese Cookies sind für den Betrieb der Website unbedingt erforderlich und können nicht 
              deaktiviert werden. Sie werden in der Regel nur als Reaktion auf von Ihnen durchgeführte 
              Aktionen gesetzt, wie z.B.:
            </p>
            <div className="bg-gray-800 rounded-lg p-4 mb-4">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-gray-700">
                    <th className="text-left py-2 text-cyan-400">Cookie</th>
                    <th className="text-left py-2 text-cyan-400">Zweck</th>
                    <th className="text-left py-2 text-cyan-400">Speicherdauer</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-700">
                    <td className="py-2">token</td>
                    <td className="py-2">Authentifizierung/Login</td>
                    <td className="py-2">Session / 7 Tage</td>
                  </tr>
                  <tr className="border-b border-gray-700">
                    <td className="py-2">user_preferences</td>
                    <td className="py-2">Benutzereinstellungen</td>
                    <td className="py-2">1 Jahr</td>
                  </tr>
                  <tr className="border-b border-gray-700">
                    <td className="py-2">cookie_consent</td>
                    <td className="py-2">Ihre Cookie-Einwilligung</td>
                    <td className="py-2">1 Jahr</td>
                  </tr>
                  <tr>
                    <td className="py-2">locale</td>
                    <td className="py-2">Spracheinstellung</td>
                    <td className="py-2">1 Jahr</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h3 className="text-xl font-semibold mb-3 mt-6">2.2 Analyse-Cookies (Optional)</h3>
            <p className="mb-4">
              Diese Cookies helfen uns zu verstehen, wie Besucher mit unserer Website interagieren, 
              indem Informationen anonym gesammelt und gemeldet werden:
            </p>
            <div className="bg-gray-800 rounded-lg p-4 mb-4">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-gray-700">
                    <th className="text-left py-2 text-cyan-400">Cookie</th>
                    <th className="text-left py-2 text-cyan-400">Anbieter</th>
                    <th className="text-left py-2 text-cyan-400">Zweck</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="py-2">_ga, _gid</td>
                    <td className="py-2">Google Analytics</td>
                    <td className="py-2">Nutzungsstatistiken (falls aktiviert)</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h3 className="text-xl font-semibold mb-3 mt-6">2.3 Drittanbieter-Cookies</h3>
            <p className="mb-4">
              Einige Funktionen unserer Website erfordern Cookies von Drittanbietern:
            </p>
            <div className="bg-gray-800 rounded-lg p-4 mb-4">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-gray-700">
                    <th className="text-left py-2 text-cyan-400">Dienst</th>
                    <th className="text-left py-2 text-cyan-400">Anbieter</th>
                    <th className="text-left py-2 text-cyan-400">Zweck</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-700">
                    <td className="py-2">Stripe</td>
                    <td className="py-2">Stripe, Inc.</td>
                    <td className="py-2">Sichere Zahlungsabwicklung</td>
                  </tr>
                  <tr>
                    <td className="py-2">YouTube</td>
                    <td className="py-2">Google LLC</td>
                    <td className="py-2">Eingebettete Videos</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 flex items-center gap-2" style={{ color: '#7CD4FD' }}>
              <Settings className="w-6 h-6" />
              3. Verwaltung von Cookies
            </h2>
            <p className="mb-4">
              Sie haben verschiedene Möglichkeiten, Cookies zu verwalten:
            </p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li>
                <strong>Cookie-Banner:</strong> Beim ersten Besuch unserer Website können Sie über das 
                Cookie-Banner Ihre Präferenzen einstellen.
              </li>
              <li>
                <strong>Browser-Einstellungen:</strong> Die meisten Browser erlauben es Ihnen, Cookies zu 
                blockieren oder zu löschen. Diese Einstellungen finden Sie in der Regel im Menü 
                "Einstellungen" oder "Datenschutz" Ihres Browsers.
              </li>
              <li>
                <strong>Opt-Out-Links:</strong> Für bestimmte Analyse-Cookies können Sie sich über 
                spezielle Opt-Out-Seiten abmelden.
              </li>
            </ul>

            <div className="bg-yellow-900 bg-opacity-20 border border-yellow-500 p-4 rounded-lg mb-4">
              <p className="text-yellow-400">
                <strong>Hinweis:</strong> Wenn Sie technisch notwendige Cookies blockieren, kann dies 
                die Funktionalität der Website beeinträchtigen. Insbesondere ist eine Anmeldung 
                ohne Cookies nicht möglich.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              4. Speicherdauer
            </h2>
            <p className="mb-4">
              Die Speicherdauer von Cookies variiert:
            </p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li><strong>Session-Cookies:</strong> Werden gelöscht, wenn Sie Ihren Browser schließen</li>
              <li><strong>Persistente Cookies:</strong> Bleiben für einen festgelegten Zeitraum auf Ihrem 
                Gerät (z.B. 1 Jahr) oder bis Sie sie manuell löschen</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              5. Rechtsgrundlage
            </h2>
            <p className="mb-4">
              Die Rechtsgrundlagen für die Verwendung von Cookies sind:
            </p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li>
                <strong>Art. 6 Abs. 1 lit. f DSGVO (Berechtigtes Interesse):</strong> Für technisch 
                notwendige Cookies, die für den Betrieb der Website unerlässlich sind
              </li>
              <li>
                <strong>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung):</strong> Für optionale Analyse- und 
                Marketing-Cookies, die erst nach Ihrer ausdrücklichen Zustimmung gesetzt werden
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              6. Ihre Rechte
            </h2>
            <p className="mb-4">
              Im Zusammenhang mit Cookies und der damit verbundenen Datenverarbeitung haben Sie folgende Rechte:
            </p>
            <ul className="list-disc ml-6 mb-4 space-y-2">
              <li>Recht auf Auskunft über die gespeicherten Daten</li>
              <li>Recht auf Berichtigung unrichtiger Daten</li>
              <li>Recht auf Löschung (soweit keine gesetzliche Aufbewahrungspflicht besteht)</li>
              <li>Recht auf Einschränkung der Verarbeitung</li>
              <li>Recht auf Widerruf einer erteilten Einwilligung</li>
              <li>Recht auf Beschwerde bei einer Aufsichtsbehörde</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              7. Kontakt
            </h2>
            <p className="mb-4">
              Bei Fragen zu dieser Cookie-Richtlinie oder zur Verarbeitung Ihrer Daten wenden Sie sich 
              bitte an:
            </p>
            <div className="bg-gray-800 rounded-lg p-4">
              <p>Andreas Trenter</p>
              <p>STR-Performance</p>
              <p>Dorfweg 8, 4718 Holderbank, Schweiz</p>
              <p className="mt-2">
                E-Mail: <a href="mailto:datenschutz@carcortex-ai.com" className="text-cyan-400 hover:underline">
                  datenschutz@carcortex-ai.com
                </a>
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4" style={{ color: '#7CD4FD' }}>
              8. Änderungen dieser Cookie-Richtlinie
            </h2>
            <p className="mb-4">
              Wir behalten uns vor, diese Cookie-Richtlinie bei Bedarf zu aktualisieren, beispielsweise 
              bei Änderungen der verwendeten Cookies oder der rechtlichen Anforderungen. Die aktuelle 
              Version finden Sie stets auf dieser Seite. Bei wesentlichen Änderungen werden wir Sie 
              angemessen informieren.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-700">
          <Link to="/" className="text-blue-400 hover:text-blue-300">
            ← Zurück zur Startseite
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CookieRichtliniePage;
